import { InnovyzeRole } from '@innovyze/stylovyze';
import { PaginationInfo } from './pagination.types';
import { Subscription } from '@innovyze/shared-utils';
import { User, UserOperationResult } from '@Types/user.types';

export interface UsersStoreState {
	initialized: boolean;
	paginatedUsers: PaginatedUsers & { initialized: boolean };
	created: boolean;
	userById: {
		initialized: boolean;
		user?: User;
	};
	bulkUser: {
		status: 'idle' | 'pending' | 'completed' | 'rejected';
		results?: UserOperationResult[];
	};
}

export interface ManageUsersFormikContext {
	internalUsers: string[];
	externalUsers: string[];
}

export type PartialUsersStoreState = Partial<UsersStoreState>;

export interface PaginatedUsers {
	users: User[];
	pagination: PaginationInfo;
}
export interface UserParams {
	pageSize?: number;
	page?: number;
	queryString?: string;
	role?: InnovyzeRole;
	entitlement?: Subscription;
	blocked?: boolean;
}

export interface UserTableSelection {
	entitlement: string | typeof ALL_ENTITLEMENTS;
	role: InnovyzeRole | typeof ALL_ROLES;
	search: string;
}

export interface UpdateRoleParams {
	role: string;
	userId: string;
}

export const ALL_ROLES = 'All Roles';
export const ALL_ENTITLEMENTS = 'All Subscriptions';
